import React from 'react';
import LogoImage from 'src/components/enterprise/navigation/Logo/LogoImage';
import { isPhoneView } from 'src/utilities/useScreenSizes';
import { getWindow } from 'src/utilities/window';

const DESKTOP_WIDTH = '114px';
const MOBILE_WIDTH = '84px';

export default function Logo(): JSX.Element {
  const isTablet = !isPhoneView();
  const window = getWindow();

  return (
    <div className="cursorPointer">
      <a href={window.location.origin}>
        <LogoImage width={isTablet ? DESKTOP_WIDTH : MOBILE_WIDTH} />
      </a>
    </div>
  );
}
